export const builtInEveryoneTeamId = "teams-everyone";
